angular.module('gym.setup', []).config(["$stateProvider", function($stateProvider) {
  return $stateProvider.state('gym.setup', {
    url: '/setup/edit',
    controller: 'SetupCtrl',
    template: require('templates/gyms/setup/setup.html.slim'),
    resolve: {
      currentUser: function() {
        return window.currentUser;
      },
      gymSetup: ["GymSetupService", function(GymSetupService) {
        return GymSetupService.get();
      }]
    }
  });
}]);
